export default __webpack_public_path__ + "static/media/education.6bf0e861.jpg";